// What the admin sees for a row of the product collection. The kiosk finds its prices
// by product and type: printing/mono, printing/colored, and photo/10x15 for one 10×15
// photo; photo/id is one sheet of ID photos, which the kiosk prints as a photo (the
// cloud's utils/photoPdf.js). A row not listed here shows its type.
const LABELS = {
	"printing/mono": { label: "Хар цагаан", unit: "нэг хуудас", icon: "fa-print" },
	"printing/colored": { label: "Өнгөт", unit: "нэг хуудас", icon: "fa-palette" },
	"photo/10x15": { label: "10×15 зураг", unit: "нэг зураг", icon: "fa-image" },
	"photo/id": { label: "Цээж зураг", unit: "нэг 10×15 хуудас", icon: "fa-id-card" },
};

// The photo rows. The page shows each without a price until the admin sets one, which
// adds it to the collection and puts it on sale. `off` is what its row says until
// then, `confirm` what the admin is asked before the first price: the site takes
// orders from then on, and only a kiosk with photos switched on (Printers → Edit) is
// given them to print.
export const PHOTO_ROWS = [
	{
		product: "photo",
		type: "10x15",
		off: "зураг хэвлэх унтраалттай",
		confirm:
			"Үнийг хадгалмагц cloudprint.mn дээр 10×15 зураг хэвлэх үйлчилгээ нээгдэнэ. " +
			"Зургийг зөвхөн Printers хэсэгт «Photo printing»-ийг асаасан киоск хэвлэнэ: " +
			"асаасан киоск байхгүй бол хэрэглэгчийн захиалга хэвлэгдэхгүй. " +
			"Үргэлжлүүлэх үү?",
	},
	{
		product: "photo",
		type: "id",
		off: "цээж зураг хэвлэх унтраалттай",
		confirm:
			"Үнийг хадгалмагц cloudprint.mn дээр цээж зураг хэвлэх үйлчилгээ нээгдэнэ. " +
			"Цээж зургийн хуудсыг 10×15 зургийн адил, зөвхөн Printers хэсэгт «Photo printing»-ийг асаасан киоск хэвлэнэ. " +
			"Үргэлжлүүлэх үү?",
	},
];

// The photo row an item of the collection is, if any
export const photoRowOf = (item) =>
	PHOTO_ROWS.find((row) => row.product === item.product && row.type === item.type);

const labelOf = (item) => LABELS[item.product + "/" + item.type];

export const productLabel = (item) => (labelOf(item) || { label: item.type }).label;

// A payment for a photo order keeps the type of the photo row it was sold at as its
// photo_type; payments for documents have none (the cloud's models/PaymentLog.js)
export const photoLabel = (photoType) => productLabel({ product: "photo", type: photoType });

// What one price buys, e.g. "нэг хуудас"
export const productUnit = (item) => (labelOf(item) || { unit: item.product }).unit;

export const productIcon = (item) => (labelOf(item) || { icon: "fa-tag" }).icon;
